import React, { useContext } from "react";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import Status from "components/common_components/Status";
import FormsContext from "../FormsContext";
import { formatDate } from "../utils";
import { findCurrentVersion } from "../utils/copyToVersion";

/** Form of a client form: its code and whether it was filled in the current version, detailed on hover. */
const FormVersionCell = ({ form }) => {
    const { resources } = useContext(FormsContext);
    if (!form) return <span>--</span>;

    const isCurrent = Boolean(form.isCurrent);
    const currentVersion = isCurrent ? null : findCurrentVersion(resources.forms, form);
    const expires = formatDate(form.expires);

    const details = (
        <div className="form-version-tooltip__content">
            <div className="form-version-tooltip__title">
                {form.code} · {isCurrent ? "Current version" : "Old version"}
            </div>
            <dl>
                <dt>Issuer</dt>
                <dd>{form.issuer?.issuer || "--"}</dd>
                <dt>Category</dt>
                <dd>{form.category?.category || "--"}</dd>
                <dt>Version</dt>
                <dd>{form.version}</dd>
                {expires && (
                    <>
                        <dt>Expires</dt>
                        <dd>{expires}</dd>
                    </>
                )}
                {currentVersion && (
                    <>
                        <dt>Current version</dt>
                        <dd>{currentVersion.version}</dd>
                    </>
                )}
            </dl>
        </div>
    );

    return (
        <span className="form-version-cell">
            <span className="form-version-cell__code">{form.code}</span>
            <Tooltip
                title={details}
                arrow
                placement="right"
                classes={{
                    tooltip: `form-version-tooltip form-version-tooltip--${isCurrent ? "current" : "old"}`,
                    arrow: `form-version-tooltip__arrow form-version-tooltip__arrow--${isCurrent ? "current" : "old"}`,
                }}
            >
                {/* Status does not forward refs, the tooltip needs an element to anchor to */}
                <span className="form-version-cell__indicator">
                    <Status id={isCurrent ? "currentVersion" : "oldVersion"} />
                </span>
            </Tooltip>
        </span>
    );
};

FormVersionCell.propTypes = {
    form: PropTypes.shape({
        id: PropTypes.number,
        code: PropTypes.string,
        version: PropTypes.string,
        isCurrent: PropTypes.bool,
        expires: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
        issuer: PropTypes.shape({ issuer: PropTypes.string }),
        category: PropTypes.shape({ category: PropTypes.string }),
    }),
};

FormVersionCell.defaultProps = {
    form: null,
};

export default FormVersionCell;
